import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from "react";
import { getLinkTitle, getLinkDescription, getLinkImageUrl, } from "@shared/blocks/link/helpers";
import wikipediaW from "./wikipedia-w.svg";
import "./view.scss";
function stopCardEvent(e) {
    e.stopPropagation();
}
/**
 * Pull the article title from the URL path as a fallback for legacy "generic"
 * Wikipedia blocks that haven't been re-ingested into the wikipedia subtype.
 */
function extractArticleTitleFromUrl(url) {
    if (!url)
        return undefined;
    try {
        const path = new URL(url).pathname;
        if (!path.startsWith("/wiki/"))
            return undefined;
        return decodeURIComponent(path.slice("/wiki/".length)).replace(/_/g, " ");
    }
    catch {
        return undefined;
    }
}
export const WikipediaBlockView = memo(({ block }) => {
    const content = block.content;
    // Prefer the structured payload from `wikipediaHandler` when present.
    // Legacy rows tagged `subtype: "generic"` still render via the URL/OG
    // fallback below until they're reingested.
    const wiki = content.subtype === "wikipedia" ? content.wikipedia : undefined;
    const articleTitle = wiki?.articleTitle?.trim() ||
        extractArticleTitleFromUrl(content.url) ||
        getLinkTitle(content)?.trim();
    const summary = wiki?.description?.trim() ?? getLinkDescription(content)?.trim();
    // `getLinkImageUrl` resolves the canonical `imageFile` (CDN URL via
    // `cdn.putty.me`) and falls back to the legacy raw `imageUrl` string
    // for rows written before `imageFile` existed.
    const imageUrl = getLinkImageUrl(content);
    return (_jsx("div", { className: "wikipedia-content", children: _jsxs("div", { className: "wikipedia-content__body", children: [content.url ? (_jsx("a", { href: content.url, target: "_blank", rel: "noopener noreferrer", className: "wikipedia-content__source", onClick: stopCardEvent, onMouseDown: stopCardEvent, children: _jsx("img", { className: "wikipedia-content__icon", src: wikipediaW, alt: "Wikipedia" }) })) : (_jsx("span", { className: "wikipedia-content__source", children: _jsx("img", { className: "wikipedia-content__icon", src: wikipediaW, alt: "Wikipedia" }) })), _jsxs("div", { className: "wikipedia-content__info", children: [articleTitle ? _jsx("div", { className: "wikipedia-content__title", children: articleTitle }) : null, summary ? _jsx("div", { className: "wikipedia-content__summary", children: summary }) : null] }), imageUrl ? (_jsx("img", { className: "wikipedia-content__image", src: imageUrl, alt: articleTitle ?? "Wikipedia article image", loading: "lazy", onMouseDown: stopCardEvent, onClick: stopCardEvent })) : null] }) }));
});
